













































import {Component, Vue} from 'vue-property-decorator';
import {Action, State} from 'vuex-class'
import PlanificacionForestalResponse,{PlanificacionCabeceraRequest} from '../../../entidades/Plantacion/PlanificacionForestalResponse';
import Alerta from '@/entidades/Sistema/Alerta';
import Loading from '@/entidades/Sistema/Loading'
@Component({
  name : 'Planificacion',
  components:{
    'tabla' :() => import('@/components/General/TablaGeneralFinal.vue'),
    'formularioAdd' : () => import('@/components/Forestal/Planificacion/FormularioAdd.vue'),
    'formularioDetalle': () => import('@/components/Forestal/Planificacion/FormularioDetalle.vue')
  }
})
export default class Planificacion extends Vue
{
  @State('usuarioId',{namespace: 'authModule'}) usuarioId!:string;
  @State('fullName',{namespace: 'authModule'}) fullName!:string;
  @Action('changeAlerta',{namespace:'sistemaModule'}) changeAlerta!:Function;
  @Action('changeLoading',{namespace:'sistemaModule'}) changeLoading!:Function;
  header:{text:string,sortable:boolean,value:string}[] =
    [
            //{text:"Jefe Zona",sortable:true,value:'jefeZona'},
            {text:"Año",sortable:true,value:'anio'},
            {text:"Mes",sortable:true,value:'mesDescripcion'},
            {text:"Actions",sortable:false,value:'actions'}
  ];
  listadoPlanificacion:Array<PlanificacionForestalResponse> = [];
  nameComponente:string="";
  nameComponenteDetalle:string="";
  procesoActual:number= 0;
  cabecera:PlanificacionForestalResponse | null = null;

    retrocederDetalle()
    {
      this.procesoActual = 1;
      this.nameComponenteDetalle = "";
    }
   abrilDetallePlanificacion(item:PlanificacionForestalResponse)
   {
     this.cabecera = item;
     this.nameComponenteDetalle = "formularioDetalle";
     this.procesoActual = 2;

   }

    async guardarPlanificacionCabecera(item:PlanificacionCabeceraRequest)
    {
       if(item != null)
       {
         item.usuarioIdMayordomo = this.usuarioId;
         item.usuarioDescripcion = this.fullName;
         var response = await PlanificacionForestalResponse.GuardarPlanificacion(item);
         if(response.isSuccess)
         {
           this.obtenerPlanificacion();
           this.nameComponente = "";
           this.changeAlerta(new Alerta(response.isMessage,true,"primary",3000));
         }
         else
         {
           this.changeAlerta(new Alerta(response.isMessage,true,"danger",3000));
         }
       }
    }
    async obtenerPlanificacion()
    {
      try
      {
        this.changeLoading(new Loading(true,"Obteniendo planificacion del mayordomo"));
        var response = await PlanificacionForestalResponse.ObtenerPlanificcion(this.usuarioId);
        if(response.isSuccess)
        {
          this.listadoPlanificacion = response.isResult;
        }
        else
        {
           this.changeAlerta(new Alerta(response.isMessage,true,"danger",3000));
        }
      }
      catch(error)
      {

      }
      finally
      {
        this.changeLoading(new Loading(false,"Obteniendo planificacion del mayordomo"));
      }
    }
    abrirModal()
    {
      this.nameComponente = "formularioAdd";
    }
    cerrarModel()
    {

      this.nameComponente = "";

    }


    get propiedades()
    {
      if(this.nameComponente == "formularioAdd")
      {
        return {'modal': true}
      }
      else if(this.nameComponenteDetalle =="formularioDetalle")
      {
        return {'item': this.cabecera}
      }
    }
    async mounted() {
      this.procesoActual = 1 ;
      await this.obtenerPlanificacion();
    }
}
